import React from 'react';
import { Navigate } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import { useAuth } from '../../App';
import JumpstartStudio from '../../components/coaching/JumpstartStudio';

export default function AdminJumpstartSessions() {
  const { user } = useAuth();
  const isCoach = user?.is_coach === true || user?.role === 'coach';
  if (!isCoach) return <Navigate to="/admin" replace />;
  return (
    <AdminLayout title="7 Stage Jumpstart Sessions">
      <JumpstartStudio />
    </AdminLayout>
  );
}
